import { StyleSheet } from '@react-pdf/renderer';

import { COLORS } from '@/shared/constants/colors';

export const styles = StyleSheet.create({
  document: {
    fontFamily: 'Garamond',
  },
  page: {
    backgroundColor: COLORS.white,
    padding: '90px 21px 220px 23px ',
  },
  watermark: {
    fontSize: '37px',
    opacity: '0.06',
    position: 'absolute',
    top: '50%',
    left: '0',
    right: '0',
    width: '995px',
    textAlign: 'center',
    transform: ' rotate(-45deg) translateY(-120%)',
  },
  header: {
    fontSize: '12.75px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 34,
    top: 16,
    position: 'absolute',
    width: 794 - 50,
  },
  section: {
    padding: 33,
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    lineHeight: 1.2,
    gap: 14,
  },
  footer: {
    fontSize: '12.75px',
    textAlign: 'center',
    position: 'absolute',
    bottom: 50,
    left: 33,
    right: 33,
    width: 794 - 66,
    borderTop: 0,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 4,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 14,
  },
  border: {
    flex: 1,
    border: `1 solid ${COLORS.colorPdfBorder}`,
    padding: '3px 2px',
  },
  spacer: {
    height: 16,
  },
  json: {},
});
